// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a413306","809":"622070e1"}[chunkId] + ".chunk.js";
};